import { render, staticRenderFns } from "./commonHead.vue?vue&type=template&id=3990aa5a&scoped=true"
import script from "./commonHead.vue?vue&type=script&lang=js"
export * from "./commonHead.vue?vue&type=script&lang=js"
import style0 from "./commonHead.vue?vue&type=style&index=0&id=3990aa5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3990aa5a",
  null
  
)

export default component.exports